module.exports = __webpack_public_path__ + "img/DE00320.c6eca198.png";